const NAMESPACE = "navSideBar";

const KEYS = {
    navSideBarLabel: "navSideBarLabel"
};

const MESSAGES = {
    [KEYS.navSideBarLabel]: {
        value: "Navigation Side Bar",
        comment: "Label for navigation side bar"
    }
};

export { KEYS, NAMESPACE, MESSAGES };
